<template>
  <div class="box10">
    <!-- <pageTitle title="采用必修+拓展模式授课<br />高效就业、灵活提升" /> -->
    <div class="block" ref="block"></div>
    <div class="title-top">
      <span>拓展课</span> — 提升职场竞争力
      <p>免费赠送</p>
    </div>

    <div class="content">
      <div class="subject-box" v-for="(item, index) in list" :key="index">
        <div class="subject" ref="item" @click="changeCur(index)">
          <div class="stage">{{ item.stage }}</div>
          <div class="title">{{ item.tit }}</div>
          <div
            class="icon"
            :class="{ 'img-rotate': cur == index && showAnswer }"
          >
            <img src="../../../assets/coursePage/ai/box6/icon-down.png" alt />
          </div>
        </div>

        <div
          v-if="index === 0"
          class="course-content"
          :class="{ 'show-answer2': cur == index && showAnswer }"
        >
          <div class="line"></div>
          <div v-if="item.target.length !== 0">
            <div class="title-icon">
              <img
                class="icon1"
                src="../../../assets/coursePage/pythonData/box9/icon1.png"
                alt
              />学习目标
            </div>

            <div class="targe">
              <p v-for="j in item.target" :key="j + 'a'">{{ j }}</p>
            </div>
          </div>

          <div v-if="item.content.length !== 0">
            <div class="title-icon">
              <img
                class="icon2"
                src="../../../assets/coursePage/pythonData/box9/icon2.png"
                alt
              />主讲内容
            </div>

            <div class="targe">
              <p v-for="i in item.content" :key="i + 'b'">{{ i }}</p>
            </div>
          </div>

          <div v-if="item.scheme !== ''">
            <div class="title-icon">
              <img
                class="icon3"
                src="../../../assets/coursePage/pythonData/box9/icon3.png"
                alt
              />主讲解决方案
            </div>

            <div class="targe">
              <p>{{ item.scheme }}</p>
            </div>
          </div>

          <div v-if="item.point.length !== 0">
            <div class="title-icon">
              <img
                class="icon4"
                src="../../../assets/coursePage/pythonData/box9/icon4.png"
                alt
              />主讲知识点
            </div>

            <div class="targe">
              <p v-for="h in item.point" :key="h + 'd'">{{ h }}</p>
            </div>
          </div>
        </div>
        <div
          v-else
          class="course-content"
          :class="{ 'show-answer2': cur == index && showAnswer }"
        >
          <div class="line"></div>

          <div v-if="item.content.length !== 0">
            <div class="title-icon">
              <img
                class="icon2"
                src="../../../assets/coursePage/pythonData/box9/icon1.png"
                alt
              />主讲内容
            </div>

            <div class="targe">
              <p>{{ item.content }}</p>
            </div>
          </div>

          <div v-if="item.scheme.length !== 0">
            <div class="title-icon">
              <img
                class="icon3"
                src="../../../assets/coursePage/pythonData/box9/icon3.png"
                alt
              />可掌握的核心能力
            </div>

            <div class="targe">
              <p v-for="i in item.scheme" :key="i + 'b'">{{ i }}</p>
            </div>
          </div>

          <div v-if="item.point.length !== 0">
            <div class="title-icon">
              <img
                class="icon4"
                src="../../../assets/coursePage/pythonData/box9/icon4.png"
                alt
              />可解决的现实问题
            </div>

            <div class="targe">
              <p>{{ item.point }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="btn" @click="openDetail">查看详细大纲</div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import check from "../../../utils/check";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      list: [
        {
          stage: "阶段一",
          tit: "保险项目",
          target: [
            "1.快速搭建保险行业大数据平台",
            "2.基于Hive+Spark SQL搭建离线数据仓库",
            "3.基于Spark SQL应对轻松应对复杂的迭代计算",
            "4.完成基于国内头部保险公司大数据项目开发",
            "5.掌握基于Spark分析12亿报单表和8千万客户等数据",
            "6.对保单汇总计算（业务发展类指标，成本费用类指标等），并向业务人员做数据展示",
            "7.离线数仓项目实战",
            "8.用户画像项目实战"
          ],
          scheme:
            "项目核心架构和业务流程、Hive数仓建模 、Sqoop数据同步开发、 DolphinScheduler任务调度、使用lag/sum等窗口函数 、使用UDAF函数计算有效保单数字段、计算现金价值、计算和准备金、分区表的使用 、指标汇总计算 、Shuffle优化、用户画像解决方案。",
          content: [],
          point: [
            "1. 基于Spark轻松应对保险复杂的迭代计算",
            "2. 基于SparkSQL完成用户画像实战",
            "3. 基于ES完成标签存储与检索",
          ],
        },
        {
          stage: "阶段二",
          tit: "BI报表",
          target: [],
          scheme: [
            "1.掌握BI报表开发需求分析",
            "2.掌握BI报表工具",
            "3.掌握FineReport报表"
          ],
          content: "掌握AI辅助SQL代码开发",
          point: "掌握使用量最广BI报表开发工具FineReport，能够基于FineReport完成不同行业BI报表开发及业务决策。",
        },
        {
          stage: "阶段三",
          tit: "阿里云Flink基础技术",
          target: [],
          scheme: [
            "1.掌握基于阿里云Flink进行实时和离线数据处理、分析；",
            "2.掌握基于阿里云Flink的多流并行处理技术；",
            "3.掌握FlinkCDC多数据源采集技术。"
          ],
          content: "阿里云Flink入门、Flink SQL、Flink作业开发、阿里云Flink运维",
          point: "掌握当下热门的流批一体化分布式计算框架阿里云Flink及其生态，解决实时计算经典场景问题，适应市场对阿里云Flink越发增长的需求。",
        },
        {
          stage: "阶段四",
          tit: "阿里云Flink实时项目",
          target: [],
          scheme: [
            "1.湖仓一体化解决方案基于Flink+Paimon湖仓一体技术架构；",
            "2.基于FlinkCDC完成MySQL等数据源的数据采集；",
            "3.FlinkSQL流批一体架构实现实时数据计算；",
            "4.使用StarRocks进行海量多维分析；",
            "5.掌握数据报表分析；",
            "6.掌握业务数据实时大屏场景实现。"
          ],
          content: "基于阿里云Flink + Kafka + Paimon 湖仓一体技术架构，实现在线视频行业大规模流数据处理和实时分析。本项目依托 阿里云 Flink 流处理计算引擎， 通过 FlinkCDC 实时采集 RDS MySQL 数据库数据，实现数据采集的断点续传，使用Kafka 作为实时数仓，使用 Paimon 实现数据的持久化和Flink 批处理，实现计算的流批一体，数据存储的湖仓一体，采用StarRocks对接DataV完成实时业务大屏展示。",
          point: "采集超过千万条在线视频的数据，实时高性能海量数据分析与存储业务数据实时大屏场景实现。",
        },
      ],
      cur: -1,
      prevItemHeight: 0,
      showAnswer: true,
    };
  },
  methods: {
    goTop(index) {
      window.scrollTo(
        0,
        this.$refs.item[index].offsetTop -
          this.$refs.block.offsetHeight -
          this.$refs.block.offsetHeight * 0.3 -
          this.prevItemHeight
      );
    },
    goTop(index) {
      window.scrollTo(
        0,
        this.$refs.item[index].offsetTop -
          this.$refs.block.offsetHeight -
          this.$refs.block.offsetHeight * 0.3 -
          this.prevItemHeight
      );
    },
    openDetail() {
      if (localStorage.getItem(`detail-${check.getUrlParam("nid")}`)) {
        window.location.href = localStorage.getItem(
          `detail-${check.getUrlParam("nid")}`
        );
      } else {
        this.clickZiXun()
      }
       this.mai("Python+大数据","查看详细大纲",0,null)
    },
    changeCur(index) {
      const a = document.querySelector(".show-answer2");
      if (a != null && index > this.cur) {
        this.prevItemHeight = a.offsetHeight;
      }
      if (!this.showAnswer || index <= this.cur) {
        this.prevItemHeight = 0;
      }
      if (index == this.cur) {
        this.showAnswer = !this.showAnswer;
        this.cur = index;
      } else {
        this.showAnswer = true;
        this.cur = index;
      }
      this.goTop(index);
    },
  },
};
</script>

<style lang="less" scoped>
.box10 {
  padding-bottom: 88px;
  width: 100%;
  background: #e5f7ff;
  .block {
    height: 80px;
  }
  .btn {
    margin: 0 auto;
    margin-top: 60px;
    width: 690px;
    height: 96px;
    background-image: linear-gradient(-5deg, #0888ff 0%, #10e0ff 100%);
    border-radius: 40px;
    text-align: center;
    font-family: PingFangSC-Semibold;
    font-size: 30px;
    line-height: 96px;
    letter-spacing: 2px;
    color: #ffffff;
    box-shadow: 0px 2px 6px 0px #207dff;
  }

  .title-top {
    position: relative;
    margin: -60px auto 0;
    margin-bottom: 40px;
    padding-left: 50px;
    width: 690px;
    height: 100px;
    background: url("../../../assets/coursePage/pythonData/box9/title.png")
      no-repeat;
    background-size: cover;
    border-radius: 20px;
    box-shadow: 0px 6px 29px 0px rgba(135, 212, 240, 0.98);
    box-sizing: border-box;
    font-family: PingFangSC-Medium;
    font-size: 28px;
    font-weight: normal;
    line-height: 100px;
    letter-spacing: 0px;
    color: #ffffff;
    display: flex;
    align-items: center;
    span {
      font-family: PingFangSC-Semibold;
      font-size: 32px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 100px;
      letter-spacing: 0px;
      color: #ffffff;
    }
    p {
      padding: 0 16px;
      height: 40px;
      background: #ffffff;
      border-radius: 8px;
      border: 1px solid #ffb650;
      margin-left: 16px;
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ff7d00;
      line-height: 40px;
      box-sizing: border-box;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      z-index: 5;
    }
    &::after {
      position: absolute;
      right: 0px;
      bottom: 0px;
      content: "";
      width: 204px;
      height: 123px;
      background: url("../../../assets/coursePage/pythonData/box9/new-icon.png")
        no-repeat;
      background-size: cover;
    }
  }

  .subject-box {
    margin: 0 auto;
    margin-bottom: 16px;
    width: 686px;
    overflow: hidden;
    background: #ffffff;
    border-radius: 16px;
  }
  .subject {
    display: flex;
    align-items: center;
    position: relative;
    padding: 24px 32px;
    width: 100%;
    height: 96px;
    background: #ffffff;
    border-radius: 16px;
    box-sizing: border-box;
    z-index: 5;
    .stage {
      font-family: PingFangSC-Semibold;
      font-size: 28px;
      font-weight: bold;
      line-height: 96px;
      letter-spacing: 0px;
      white-space: nowrap;
      color: #3dafff;
    }

    .title {
      margin-left: 24px;
      margin-right: 20px;
      font-family: PingFangSC-Medium;
      font-size: 28px;
      font-weight: bold;
      font-stretch: normal;

      letter-spacing: 0px;
      color: #24375c;
      width: 496px;
    }

    .icon {
      width: 28px;
      height: 28px;
      transition: 0.5s ease all;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .img-rotate {
      transition: 0.5s ease all;
      transform: rotate(180deg);
    }

    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #4e5969;
  }

  .course-content {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    background: #fff;
    max-height: 0;
    opacity: 0;
    padding: 0 40px;
    transition: 0.3s ease all;

    overflow: hidden;
    z-index: 3;

    .line {
      margin: 0 auto;
      margin-bottom: 32px;
      width: 622px;
      margin-left: -8px;
      height: 1px;
      background: #f2f3f5;
    }
  }

  .show-answer2 {
    padding: 0px 40px;
    // padding-bottom: 40px;
    // display: block;
    max-height: 2500px;
    opacity: 1;
    transition: 0.4s ease all;
    border-radius: 16px;
  }

  .title-icon {
    display: flex;
    align-items: center;
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1d2129;
    line-height: 44px;
    margin-bottom: 16px;

    img {
      margin-right: 12px;
      width: 32px;
      height: 32px;
    }
  }

  .main-content {
    margin-bottom: 20px;
    display: flex;
    flex-wrap: wrap;
    .block {
      margin-bottom: 16px;
      margin-right: 16px;
      padding: 0px 16px;
      height: 44px;
      background: rgba(179, 227, 254, 0.32);
      border-radius: 8px;

      font-size: 22px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
    }
  }

  .targe {
    margin-bottom: 48px;
    font-size: 26px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #4e5969;
    line-height: 44px;
    margin-left: 44px;
    p {
      position: relative;
      // &::before {
      //   content: "";
      //   display: block;
      //   width: 4px;
      //   height: 4px;
      //   background: #86909c;
      //   position: absolute;
      //   left: -22px;
      //   top: 18px;
      //   border-radius: 50%;
      // }
    }
  }
}
</style>
